var map = {
	"./medal.png": "3ad8",
	"./medal0.png": "4fed",
	"./medal1.png": "e8d3",
	"./medal2.png": "6135",
	"./medal3.png": "c876",
	"./medal4.png": "973a",
	"./medal5.png": "4677"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "74a8";